import { render, staticRenderFns } from "./ClientLogin.vue?vue&type=template&id=32a0fc84&scoped=true&"
import script from "./ClientLogin.vue?vue&type=script&lang=js&"
export * from "./ClientLogin.vue?vue&type=script&lang=js&"
import style0 from "./ClientLogin.vue?vue&type=style&index=0&id=32a0fc84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0fc84",
  null
  
)

export default component.exports